import "./jiffymade-landing-faq.scss";

const $getFaqQuestions = () => document.querySelectorAll(".js-jiffymade-landing-faq-link");

const SHOWN_CLASS = "jiffymade-landing-faq__faq-item--shown";

document.addEventListener("DOMContentLoaded", () => {
  $getFaqQuestions().forEach(faqQuestion => {
    faqQuestion.addEventListener("click", () => {
      faqQuestion.parentElement?.classList.toggle(SHOWN_CLASS);
    });
  });
});
